import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/icon-smile.svg'


const _hoisted_1 = { class: "asEmpty" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "asEmpty_icon"
}, null, -1)
const _hoisted_3 = { class: "asEmpty_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.$t('itEmpty')), 1)
      ])
    ]),
    (_ctx.name)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: _ctx.link,
          class: "asEmpty_button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.name), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}